angular.module('gym.calendar').controller('ShowEventCtrl', ["gym", "event", "classroom", "loadingAnimation", "flash", "$scope", "$state", "$stateParams", "$modal", "$window", "$filter", "$http", "$interval", "$q", "CalendarService", "EventMessageService", "ContactBadgeService", "FeatureAvailabilityService", "LateCancellationService", "MessageService", "GTMService", "EventService", "KioskService", "forms", "styles", "eventTypes", function(gym, event, classroom, loadingAnimation, flash, $scope, $state, $stateParams, $modal, $window, $filter, $http, $interval, $q, CalendarService, EventMessageService, ContactBadgeService, FeatureAvailabilityService, LateCancellationService, MessageService, GTMService, EventService, KioskService, forms, styles, eventTypes) {
  var addSingleBooking, eventId, gymId, intervalId, loadBookings, openBulkBookingsModal, reloadAttendance, selectBookingType;
  $scope.gym = gym.attributes;
  $scope.event = event.attributes;
  $scope.classroom = classroom.attributes;
  $scope.trainers = $scope.event.instructor_names.join(', ');
  gymId = $scope.gym.id;
  eventId = $scope.event.id;
  $scope.currency = $scope.gym.currency_symbol;
  $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
  $scope.eventStyles = EventService.eventStyleNames(event.attributes, styles);
  $scope.eventTypes = EventService.eventTypeNames(event.attributes, eventTypes);
  GTMService.trackPage('Event details');
  $scope.eventStatus = EventService.status($scope.event);
  $scope.event.start_at = new Date($scope.event.start_at);
  $scope.event.end_at = new Date($scope.event.end_at);
  loadBookings = function() {
    return EventService.getBookings($scope.event.id).then(function(bookings) {
      return $scope.bookings = bookings;
    });
  };
  loadBookings();
  intervalId = $interval(function() {
    loadBookings();
    return $scope.reloadEvent();
  }, 20000);
  $scope.$on('$destroy', function() {
    return $interval.cancel(intervalId);
  });
  $scope.selectedTab = 'details';
  $scope.orderContactsBy = 'last_name';
  $scope.getSortedValue = function(booking) {
    return booking.student[$scope.orderContactsBy];
  };
  $scope.setOrderBy = function(orderBy) {
    return $scope.orderContactsBy = orderBy;
  };
  $scope.setTab = function(tab) {
    return $scope.selectedTab = tab;
  };
  $scope.save = function() {
    var url;
    GTMService.trackPage('Event details', 'Save note');
    url = `/gyms/${gymId}/calendar/events/${eventId}/update_notes`;
    return $http.put(url, {
      event: {
        notes: $scope.event.notes
      }
    }).then(function() {
      return flash.success = 'Saved successfully';
    });
  };
  $scope.getContactBadge = function(type, status) {
    return ContactBadgeService.get(type, status);
  };
  $scope.addBooking = function(contact) {
    var message, prospectBookingLimit;
    if ($scope.event.all_events_count > 1) {
      openBulkBookingsModal(contact);
    } else {
      prospectBookingLimit = $scope.gym.gym_booking_detail.prospect_booking_limit;
      if (contact.type === 'prospect' && prospectBookingLimit !== null && contact.non_absent_booking_count >= prospectBookingLimit) {
        message = `This prospect has already made ${contact.non_absent_booking_count} booking(s). Click Save below to proceed and create the booking anyway.`;
        MessageService.message({
          title: 'Add booking',
          message: message,
          confirmButtonText: 'Save'
        }).then(function() {
          return addSingleBooking(contact);
        });
      } else {
        addSingleBooking(contact);
      }
    }
    return $scope.search = '';
  };
  openBulkBookingsModal = function(contact) {
    var bulkBookingsModal;
    bulkBookingsModal = $modal.open({
      template: require('templates/gyms/calendar/bulkBookingModal.html.slim'),
      controller: 'BulkBookingsCtrl',
      size: 'lg',
      resolve: {
        event: function() {
          return $scope.event;
        },
        contact: function() {
          return contact;
        },
        bookings: function() {
          return event.bookings();
        }
      }
    });
    return bulkBookingsModal.result.then(function(data) {
      loadBookings();
      return $scope.reloadEvent();
    });
  };
  selectBookingType = function(contact) {
    var deferred, modal;
    deferred = $q.defer();
    if (contact.type === 'member' && !$scope.event.free_class) {
      modal = $modal.open({
        template: require('templates/gyms/calendar/selectBookingTypeModal.html.slim'),
        controller: 'SelectBookingTypeCtrl',
        resolve: {
          event: function() {
            return $scope.event;
          },
          contact: function() {
            return contact;
          }
        }
      });
      modal.result.then(function(data) {
        return deferred.resolve(data);
      });
    } else {
      deferred.resolve({
        free_class: false
      });
    }
    return deferred.promise;
  };
  addSingleBooking = function(contact) {
    return selectBookingType(contact).then(function(data) {
      var newBooking, params;
      params = {
        student: contact,
        free_class: data.free_class,
        add_makeup_class: data.add_makeup_class,
        makeup_class_membership_id: data.makeup_class_membership_id,
        makeup_class_reason: data.makeup_class_reason
      };
      newBooking = event.bookings().build(params);
      return newBooking.save().then(function(booking) {
        var student;
        student = booking.attributes.student;
        flash.success = `Booking added for ${student.first_name} ${student.last_name}`;
        loadBookings();
        return $scope.reloadEvent();
      }, function(response) {
        var studentName;
        newBooking.delete();
        data = response.data;
        studentName = data.student.name || `${data.student.first_name} ${data.student.last_name}`;
        if (data.errors.event) {
          flash.error = `Booking for ${studentName} failed: ${data.errors.event.join(', ')}`;
        }
        if (data.errors.student) {
          return MessageService.message({
            title: 'Cannot add booking',
            message: data.errors.student[0],
            displayOkButton: true
          });
        }
      });
    });
  };
  $scope.addToWaitlist = function(contact) {
    var url;
    $scope.search = '';
    url = `/gyms/${gymId}/calendar/events/${eventId}/waitlist_attendees`;
    return $http.post(url, {
      contact_id: contact.id
    }).then(function(response) {
      $scope.reloadEvent();
      return flash.success = `${response.data.contact_name} added to waitlist`;
    }, function(response) {
      if (response.data.error_message) {
        return flash.error = response.data.error_message;
      }
    });
  };
  $scope.removeFromWaitlist = function(waitlist) {
    return EventService.removeFromWaitlist(waitlist).then(function() {
      return $scope.reloadEvent();
    });
  };
  $scope.changeWaitlistPosition = function(waitlist, change) {
    return EventService.changeWaitlistPosition(waitlist, change).then(function() {
      return $scope.reloadEvent();
    });
  };
  $scope.reloadEvent = function() {
    var url;
    url = `/gyms/${gymId}/calendar/events/${eventId}`;
    return $http.get(url).then(function(response) {
      $scope.event.waitlist_attendees = response.data.waitlist_attendees;
      $scope.event.waitlist_enabled = response.data.waitlist_enabled;
      $scope.event.waitlist_full = response.data.waitlist_full;
      $scope.event.invite_to_waitlist = response.data.invite_to_waitlist;
      $scope.event.late_cancellations = response.data.late_cancellations;
      return $scope.event.non_absent_bookings_count = response.data.non_absent_bookings_count;
    });
  };
  $scope.editEvent = function() {
    return EventService.goToEdit(event.attributes);
  };
  $scope.attendanceField = _.find(_.find(forms, {
    name: 'bookings'
  }).fields, {
    name: 'attendance'
  });
  $scope.deleteEvent = function() {
    return CalendarService.deleteEvent($scope, event);
  };
  $scope.cancelEvent = function() {
    return $state.go('gym.cancelEvent', {
      eventId: eventId
    });
  };
  $scope.addMakeUpClassAvailable = function(booking) {
    return $scope.permissions.manage_makeup_classes && booking.attendance === 'Absent' && booking.membership_id && !booking.membership_archived;
  };
  $scope.addMakeUpClass = function(booking) {
    var modalInstance;
    return modalInstance = $modal.open({
      template: require('templates/components/membership/membership_make_up_modal.html.slim'),
      resolve: {
        membership: function() {
          return {
            id: booking.membership_id,
            label: booking.membership_name,
            expiration_date: booking.membership_expiration_date
          };
        },
        makeUpClass: function() {
          return {};
        },
        contact: function() {
          return booking.student;
        }
      },
      controller: 'MembershipMakeUpClassModalCtrl'
    });
  };
  $scope.showInfo = function(booking) {
    var modalInstance;
    return modalInstance = $modal.open({
      template: require('templates/gyms/calendar/events/booking_info_modal.html.slim'),
      resolve: {
        booking: function() {
          return booking;
        }
      },
      controller: 'BookingInfoCtrl'
    });
  };
  $scope.deleteBooking = function(booking) {
    var modalInstance;
    if ($scope.event.restrict_cancellations && !booking.cancellable && booking.allow_late_cancellations) {
      return LateCancellationService.cancel(booking).result.then(function() {
        loadBookings();
        $scope.reloadEvent();
        return flash.success = "Booking successfully cancelled";
      });
    } else {
      modalInstance = $modal.open({
        template: require('templates/gyms/calendar/cancel_bookings_modal.html.slim'),
        resolve: {
          booking: function() {
            return booking;
          },
          contact: function() {
            return booking.student;
          },
          fromContactProfile: function() {
            return false;
          }
        },
        controller: 'CancelBookingsCtrl'
      });
      return modalInstance.result.then(function() {
        loadBookings();
        return $scope.reloadEvent();
      });
    }
  };
  $scope.isFeePresent = function(fee) {
    return fee && parseFloat(fee) > 0;
  };
  reloadAttendance = function() {
    loadBookings();
    return $scope.reloadEvent();
  };
  $scope.updateAttendance = function(booking, previousValue) {
    return EventService.confirmUpdateAttendance({
      event: $scope.event,
      booking: booking,
      studentName: booking.student.name,
      previousValue: previousValue,
      reloadAttendance: reloadAttendance
    });
  };
  $scope.messageAttendees = function() {
    GTMService.trackPage('Event details', 'Message attendees');
    EventMessageService.messageAttendees($scope.event.bookings);
    return $state.go('gym.bulkMessages.new', {
      eventId: eventId
    });
  };
  $scope.goToRollCall = function() {
    var url;
    GTMService.trackPage('Event details', 'Enter roll call');
    if ($scope.attendanceFeatureAvailable) {
      url = `/gyms/${gymId}/roll_call/${eventId}`;
      $window.open(url, '_self');
      return true;
    } else {
      return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
    }
  };
  $scope.goToEventKiosk = function() {
    var params;
    GTMService.trackPage('Event details', 'Enter kiosk mode');
    if ($scope.attendanceFeatureAvailable) {
      params = {
        event_id: $stateParams.eventId,
        location_id: $stateParams.location_id
      };
      return KioskService.enterClassKioskMode(params);
    } else {
      return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
    }
  };
  $scope.isOverbooked = function() {
    return $scope.event.non_absent_bookings_count > $scope.event.participant_limit;
  };
  $scope.noPlacesAvailable = function() {
    return $scope.event.non_absent_bookings_count >= $scope.event.participant_limit;
  };
  $scope.getCancelledBookingsCount = function() {
    if (!$scope.bookings) {
      return 0;
    }
    return $scope.bookings.filter(function(booking) {
      var ref;
      return !((ref = booking.move_details) != null ? ref.moved_to_event_id : void 0);
    }).length;
  };
  $scope.getMovedBookingsCount = function() {
    if (!$scope.bookings) {
      return 0;
    }
    return $scope.bookings.filter(function(booking) {
      var ref;
      return (ref = booking.move_details) != null ? ref.moved_to_event_id : void 0;
    }).length;
  };
  $scope.isBookingMoved = function(booking) {
    var ref;
    return ((ref = booking.move_details) != null ? ref.moved_to_event_id : void 0) != null;
  };
  $scope.formatEventDateTime = function(startAt, endAt) {
    var dateStr, endDate, endTimeStr, startDate, startTimeStr;
    if (!(startAt && endAt)) {
      return '';
    }
    startDate = new Date(startAt);
    endDate = new Date(endAt);
    dateStr = $filter('date')(startDate, 'EEE d MMM yyyy');
    startTimeStr = $filter('date')(startDate, 'h:mm a');
    endTimeStr = $filter('date')(endDate, 'h:mm a');
    return `${dateStr}, ${startTimeStr} - ${endTimeStr}`;
  };
  return $scope.messageContact = function(booking) {
    var contactId, contactType;
    GTMService.trackPage('Event details', 'Message contact from cancelled booking');
    contactId = booking.student.id;
    contactType = booking.student.type;
    return $state.go('gym.bulkMessages.new', {
      contactIds: [contactId],
      contactType: contactType
    });
  };
}]);
